import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Desktop Clients Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Desktop Clients Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/desktop-clients',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
